import { IntlShape } from "react-intl";

import IntegrationUser from "@app/types/integrations/IntegrationUser";

const getStep1ErrorMessage = (
  intl: IntlShape,
  integrationUsers: IntegrationUser[]
): string | undefined => {
  if (!integrationUsers.some(({ syncing }) => syncing)) {
    return intl.formatMessage({
      id: "integrations.edit.step1.userError.notSelected",
      defaultMessage: "At least one crm user must be mapped with MMC user to setup integration",
      description: "Integration map user error - no user selected",
    });
  }
  const userIds = integrationUsers.map(({ userId }) => userId).filter((userId) => userId);
  if (userIds.some((userId, index) => userIds.indexOf(userId) !== index)) {
    return intl.formatMessage({
      id: "integrations.edit.step1.userError.tooManyAssociations",
      defaultMessage: "You cannot match more than one CRM user to a single Map My Customers user.",
      description: "Integration map user error - more than 1 crm user associated with 1 mmc user",
    });
  }
  return undefined;
};

export default getStep1ErrorMessage;
